import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Col } from "reactstrap";

// Modal Video 
import ModalVideo from 'react-modal-video'
import '../../../node_modules/react-modal-video/scss/modal-video.scss';

//Import Images

class Tutorial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            videoId: props.videoId,
            thumbnail: props.thumbnail
        }
        this.openModal = this.openModal.bind(this);
    }

    openModal() {
        this.setState({ isOpen: true })
    }

    render() {
        return (
            <React.Fragment>
                <Col xs="4" className="mb-60">
                    <div className="position-relative" style={{ zIndex: "1" }} data-aos="zoom-in" data-aos-duration="1600">
                        <img src={this.state.thumbnail} className="rounded img-fluid mx-auto d-block" alt="" />
                        <div className="play-icon">
                            <Link id="tutorial-video-playBtn" to="#" onClick={this.openModal} className="play-btn video-play-icon">
                                <i className="mdi mdi-play text-primary rounded-pill bg-white shadow"></i>
                            </Link>
                        </div>
                    </div>
                    <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.state.videoId} onClose={() => this.setState({ isOpen: false })} />
                </Col>                 
            </React.Fragment>
        );
    }
}

export default Tutorial;